// extracted by mini-css-extract-plugin
export var blockContent = "styles-module--blockContent--mOcvn";
export var listItem = "styles-module--listItem--0ZvPL";
export var orderedList = "styles-module--orderedList--l4Uai";
export var unorderedList = "styles-module--unorderedList--6bIaO";